import type { QuizLibrarySearchItem } from '@/api/gen/_model/quizLibrarySearchItem';

import { toFolderFromSearch } from '../../quiz-folder';
import type { LibraryItem } from '../types/library.types';

/**
 * 서버 판별자(`type`)를 도메인 판별자(`kind`)로 옮긴다. `type` 을 읽는 유일한 지점이다.
 *
 * `type` 이 없는 응답은 퀴즈로 본다 — 던지면 목록 한 줄 때문에 페이지 전체가 빈다.
 */
export const toLibraryItem = (raw: QuizLibrarySearchItem): LibraryItem =>
  raw.type === 'QUIZSET_FOLDER'
    ? {
        kind: 'FOLDER',
        id: raw.id,
        folder: toFolderFromSearch(raw),
      }
    : { kind: 'QUIZ', id: raw.id, quiz: raw };
